app.controller("StudentNewNotificationsController", [
    "$scope", "$stateParams", "Students", "FreshModal", "$state", "NotificationService", "$rootScope", "usSpinnerService",
    function ($scope, $stateParams, Students, FreshModal, $state, NotificationService, $rootScope, usSpinnerService) {
        $scope.notifications = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.state = $stateParams.state || 'unread';
        $scope.filterDates = [{
            _id: 'all',
            name: 'ყველა'
        }, {
            _id: 'week',
            name: 'ბოლო კვირა'
        }, {
            _id: 'month',
            name: 'ბოლო თვე'
        }, {
            _id: 'year',
            name: 'ბოლო წელი'
        }];
        $scope.filterDate = $stateParams.date ? _.find($scope.filterDates, {_id: $stateParams.date}) : $scope.filterDates[0];

        $scope.changeState = function (state) {
            $scope.state = state;
            $state.go(".", {
                page: $stateParams.page,
                state: state,
                date: $scope.filterDate._id
            });
        };

        loadPage($stateParams.page, $scope.state, $scope.filterDate, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.selectDate = function (date) {
            $scope.filterDate = date;
            $state.go(".", {
                page: $stateParams.page,
                state: $stateParams.state,
                date: date._id
            });
        };

        $scope.mark = function (notification) {
            NotificationService.mark({
                notification: notification._id,
                state: 'read'
            }).then(function () {
                loadPage($stateParams.page, $scope.state, $scope.fromDate, $scope.toDate);
                $rootScope.$broadcast('notificationCount', {});
            });
        };

        $scope.markUnread = function (notification, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            NotificationService.mark({
                notification: notification._id,
                state: 'unread'
            }).then(function () {
                loadPage($stateParams.page, $scope.state, $scope.fromDate, $scope.toDate);
                $rootScope.$broadcast('notificationCount', {});
            })
        };

        $scope.getTime = function (item) {
            var now = new Date;
            var sendDate = new Date(item.createDate);
            var pastHours = Math.round((now.getTime() - sendDate.getTime()) / (60 * 60 * 1000));
            var pastMinutes = Math.round((now.getTime() - sendDate.getTime()) / (60 * 1000));

            if (pastHours < 1) return pastMinutes + " წუთის წინ";
            else if (1 < pastHours && pastHours < 24) return pastHours + " საათის წინ";
            else return item.notification.createDateString;
        };

        $scope.open = function (item, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "StudentNewNotificationWindowController",
                templateUrl: _pb + 'student-new/notification-window.html',
                windowTemplateUrl: _pb + 'student-new/modal-layout.html',
                openedClass: "theme",
                windowTopClass: "higher-z-index light",
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            })
                .then(function (result) {

                });
            $scope.mark(item)
        };

        function loadPage(page, state, date, cb) {

            function assignDates(date) {
                if (date._id !== 'all') {
                    $scope.toDate = moment().valueOf();
                    if (date._id === 'week') {
                        $scope.fromDate = moment().subtract(7, 'days').valueOf();
                    } else if (date._id === 'month') {
                        $scope.fromDate = moment().subtract(1, 'months').valueOf();
                    } else if (date._id === 'year') {
                        $scope.fromDate = moment().subtract(1, 'years').valueOf();
                    }
                } else {
                    $scope.toDate = undefined;
                    $scope.fromDate = undefined;
                }
            }


            cb = cb || function () {
            };
            assignDates(date);
            usSpinnerService.spin("root");
            NotificationService.received({
                page: page,
                state: state,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.notifications = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }
    }
]);